export default __webpack_public_path__ + "static/media/gateio.14235216.svg";